/* import __COLOCATED_TEMPLATE__ from './quantity-select.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();